import React from 'react';
import { cx } from 'linaria';
import { cartTextItemStyle } from './CartTextItem.style';
export const CartTextItem = ({ text }) => {
  return (
    <label className={cx('cart-text', cartTextItemStyle)}>{text?.value}</label>
  );
};
